<template>
  <div class="custom-selected" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ selected }}
      <font-awesome-icon :icon="['far', 'chevron-down']" />
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
    };
  },
  mounted() {
    this.$emit("input", this.selected);
  },
  methods:{
    reset(){
        this.selected = this.default;
    }
  },
  watch : {
    'default': function (){
        this.selected = this.default;
    }
  }
};
</script>

<style scoped>
.custom-selected {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 36px;
  line-height: 36px;

  /* @include media-breakpoint-up(md) {
    padding-left: 1rem;
    padding-right: 1rem;  
  } */
  
}

.custom-selected .selected {
  background-color: var(--ion-color-white);
  border-radius: 8px;
  /* border: 1px solid var(--ion-color-white); */
  color: var(--ion-color-grey);
  padding-left: 0.75rem;
  padding-right: 1.85rem;
  cursor: pointer;
  user-select: none;
  text-overflow: ellipsis;
  overflow: hidden;  
  white-space: nowrap;
  width:100%;
}

.custom-selected .selected.open {
  border: 1px solid var(--ion-color-grey-light);
  border-radius: 6px 6px 0px 0px;
}

/* .custom-selected .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: var(--ion-color-grey) transparent transparent transparent;
} */

.custom-selected .items {
  color: var(--ion-color-grey);
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  border-right: 1px solid var(--ion-color-grey-light);
  border-left: 1px solid var(--ion-color-grey-light);
  border-bottom: 1px solid var(--ion-color-grey-light);
  position: absolute;
  background-color: var(--ion-color-white);
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-selected .items div {
  color: var(--ion-color-grey);
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-selected .items div:hover {
  background-color: var(--ion-color-grey-light);
}

.custom-selected svg {
    right: 1rem;
 }

.selectHide {
  display: none;
}

.custom-selected.disabled{
  opacity:0.2;
  pointer-events: none;
  cursor:default;
}
</style>
